import { render, staticRenderFns } from "./FeedbackFormBox.vue?vue&type=template&id=29f5466b"
import script from "./FeedbackFormBox.vue?vue&type=script&lang=js"
export * from "./FeedbackFormBox.vue?vue&type=script&lang=js"
import style0 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./FeedbackFormBox.vue?vue&type=style&index=2&id=29f5466b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports